'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  text-decoration: none;\n  cursor: default;\n  ', '\n'], ['\n  display: flex;\n  text-decoration: none;\n  cursor: default;\n  ', '\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  display: none;\n  ', '\n'], ['\n  display: none;\n  ', '\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n      display: flex;\n    '], ['\n      display: flex;\n    ']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n'], ['\n  ', '\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _templateObject7 = (0, _taggedTemplateLiteral3.default)(['\n  flex-grow: 1;\n  margin-left: 16px;\n  margin-right: 16px;\n  padding: 8px 0;\n'], ['\n  flex-grow: 1;\n  margin-left: 16px;\n  margin-right: 16px;\n  padding: 8px 0;\n']),
    _templateObject8 = (0, _taggedTemplateLiteral3.default)(['\n  color: #4a4a4a;\n  font-size: 14px;\n  ', '\n'], ['\n  color: #4a4a4a;\n  font-size: 14px;\n  ', '\n']),
    _templateObject9 = (0, _taggedTemplateLiteral3.default)(['\n    font-size: 16px;\n  '], ['\n    font-size: 16px;\n  ']),
    _templateObject10 = (0, _taggedTemplateLiteral3.default)(['\n  font-weight: normal;\n  color: #6e0ad6;\n  font-size: 10px;\n  ', '\n'], ['\n  font-weight: normal;\n  color: #6e0ad6;\n  font-size: 10px;\n  ', '\n']),
    _templateObject11 = (0, _taggedTemplateLiteral3.default)(['\n    font-size: 14px;\n  '], ['\n    font-size: 14px;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _View = require('../../atoms/View');

var _View2 = _interopRequireDefault(_View);

var _Text = require('../../fundamentals/Text');

var _Text2 = _interopRequireDefault(_Text);

var _ChevronIcon = require('../../atoms/ChevronIcon');

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

var _UserAvatar = require('../../atoms/UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _medias = require('../../../util/medias');

var _medias2 = _interopRequireDefault(_medias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = _styledComponents2.default.a(_templateObject, function (props) {
  return props.href && '\n    cursor: pointer;\n    & * {\n      cursor: pointer;\n    }\n  ';
});

var Column = (0, _styledComponents2.default)(_View2.default)(_templateObject2);

var UserAvatarBig = (0, _styledComponents2.default)(_UserAvatar2.default)(_templateObject3, _medias2.default.medium(_templateObject4));

var UserAvatarSmall = (0, _styledComponents2.default)(_UserAvatar2.default)(_templateObject5, _medias2.default.medium(_templateObject6));

var UserNameColumn = (0, _styledComponents2.default)(Column)(_templateObject7);

var UserNameWrapper = (0, _styledComponents2.default)(_Text2.default)(_templateObject8, _medias2.default.medium(_templateObject9));

var MinhaContaWrapper = (0, _styledComponents2.default)(_Text2.default)(_templateObject10, _medias2.default.medium(_templateObject11));

var LoggedUserLinkMenu = function LoggedUserLinkMenu(props) {
  var userName = props.userName,
      profilePictureUrl = props.profilePictureUrl,
      href = props.href,
      className = props.className;

  return _react2.default.createElement(
    Content,
    { href: href, className: className },
    _react2.default.createElement(
      Column,
      null,
      _react2.default.createElement(UserAvatarBig, {
        size: 46,
        alt: userName,
        fgColor: '#ffffff',
        bgColor: '#b0b9c4',
        imageUrl: profilePictureUrl
      }),
      _react2.default.createElement(UserAvatarSmall, {
        size: 36,
        alt: userName,
        fgColor: '#ffffff',
        bgColor: '#b0b9c4',
        imageUrl: profilePictureUrl
      })
    ),
    _react2.default.createElement(
      UserNameColumn,
      null,
      _react2.default.createElement(
        UserNameWrapper,
        null,
        userName
      ),
      _react2.default.createElement(
        MinhaContaWrapper,
        null,
        'Minha conta'
      )
    ),
    _react2.default.createElement(
      Column,
      null,
      _react2.default.createElement(_ChevronIcon2.default, { direction: 'right', color: '#a4a4a4', size: 16 })
    )
  );
};

LoggedUserLinkMenu.propTypes = {
  className: _propTypes2.default.string,
  userName: _propTypes2.default.string.isRequired,
  profilePictureUrl: _propTypes2.default.string,
  href: _propTypes2.default.string
};

exports.default = LoggedUserLinkMenu;